import Model, { attr } from '@ember-data/model';

export default class Result extends Model {
  @attr('date') created_at;
  @attr('number') position;
}
